import { biToast } from '@pulsepointinc/bi-components';
import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../../lib';
import {
  type GetReleasesRequest,
  getReleases,
  type ReadReleaseRequest,
  type ReadReleaseResponse,
  readRelease,
} from '../../lib/api/releases';
import { API_TAGS } from '../../lib/constants';

export function useGetReleases(params: GetReleasesRequest) {
  return useQuery({
    queryKey: [API_TAGS.Releases, params],
    queryFn: () => getReleases(params),
    meta: {
      onError: () => {
        biToast.error('Failed to Load', 'Unable to load releases. Please refresh the page.');
      },
    },
    enabled: Object.values(params).every(Boolean),
  });
}

export function useReadRelease() {
  return useMutation<ReadReleaseResponse, unknown, ReadReleaseRequest>({
    mutationFn: readRelease,
    onError: () => {
      biToast.error('Update Failed', 'Unable to mark release as read. Please try again.');
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [API_TAGS.Releases],
      });
    },
  });
}
